import * as actionTypes from './actionTypes';

const initialState = {
    authDetails: [],
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.UPDATE_LOGIN_DETAILS:
            state = {
                ...state,
                authDetails: action.payload.data,
            }
            break;
        default:
            state = { ...state };
            break;

    }
    return state;
}

export default reducer;